import type { IMediaFile, IUser } from '@condo/domain';
import { MediaFileVariant } from '@condo/domain';

/**
 * Prefer thumb variant URL for small avatars (matches ContactAvatarPanel / MentionList).
 */
export function getContactAvatarThumbUrl(mediaFile?: IMediaFile | null): string | undefined {
    if (!mediaFile) return undefined;
    const thumbPath = mediaFile.variants?.find(v => v.variant === MediaFileVariant.Thumb)?.path;
    return thumbPath ?? mediaFile.path;
}

/**
 * Firebase profile photo, then contact-uploaded avatar (same precedence as useReviewerSearch).
 */
export function resolvePersonImageSrcFromUser(user: IUser | null | undefined): string | undefined {
    if (!user) return undefined;
    if (user.photoURL) return user.photoURL;
    return getContactAvatarThumbUrl(user.contact?.avatarMediaFile);
}
